import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useCourses } from '../courses/Courses';
import { useGrades } from '../grades/Grades';
import { useInstitutions } from '../institutions/Institutions';
import { useSeries } from '../series/Series';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
  },
}));

function useForm(e) {
  const [entries, setEntries] = useState([]);

  // let a = courses.filter(item => item.grade._id === entries.grade)
  // setCourses(a)

  function handleChange(e) {
    let { name, value } = e.target;
    if (value.includes('{') && value.includes('}')) {
      value = JSON.parse(value);
    }
    setEntries({ ...entries, [name]: value });
  }

  return {
    handleChange,
    entries,
  };
}

export function CreateStudent() {
  const classes = useStyles();
  const { handleChange, entries } = useForm();
  const { grades } = useGrades();
  const { courses, setCourses } = useCourses();
  const { series } = useSeries();
  const { institutions } = useInstitutions();
  const navigate = useNavigate();

  const handleCreate = async () => {
    const response = await fetch(
      'https://api.edicionesmilenio.com/api/students',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(entries),
      }
    );
    if (response.status === 201) {
      navigate('/admin/students');
    } else {
      let json = await response.json();
      alert(json.message);
    }
  };

  useEffect(() => {
    if (entries?.grade) {
      fetch('https://api.edicionesmilenio.com/api/courses/filter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ grade: entries?.grade }),
      })
        .then((res) => res.json())
        .then((data) => setCourses(data?.data));
    }
  }, [entries?.grade, setCourses]);

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="institution-label">Institución</InputLabel>
        <Select
          labelId="institution-label"
          id="institution"
          name="institution"
          value={entries?.institution}
          onChange={handleChange}
          label="Institución"
        >
          {institutions.map((institution) => (
            <MenuItem value={institution?._id}>{institution?.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="grade-label">Grado</InputLabel>
        <Select
          labelId="grade-label"
          id="grade"
          name="grade"
          value={entries?.grade}
          onChange={handleChange}
          label="Grado"
        >
          {grades.map((grade) => (
            <MenuItem value={grade?._id}>{grade?.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="course-label">Curso</InputLabel>
        <Select
          labelId="course-label"
          id="course"
          name="course"
          value={entries?.course}
          onChange={handleChange}
          label="Curso"
        >
          {courses.map((course) => (
            <MenuItem
              value={course?._id}
            >{`${course?.numericName} (${course?.alphaName})`}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="series-label">Series</InputLabel>
        <Select
          labelId="series-label"
          id="series"
          name="series"
          value={entries?.series || []}
          onChange={handleChange}
          label="Series"
          multiple
        >
          {series.map((serie) => (
            <MenuItem value={serie?._id}>{serie?.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        className={classes.input}
        label="Correo electrónico"
        variant="outlined"
        name="email"
        onChange={handleChange}
        value={entries?.email}
        type={'email'}
      />
      <TextField
        className={classes.input}
        label="Contraseña"
        variant="outlined"
        name="password"
        onChange={handleChange}
        value={entries?.password}
        type={'password'}
      />
      <TextField
        className={classes.input}
        label="Nombre"
        variant="outlined"
        name="name"
        onChange={handleChange}
        value={entries?.name}
      />
      <TextField
        className={classes.input}
        label="Apellido"
        variant="outlined"
        name="lastName"
        onChange={handleChange}
        value={entries?.lastName}
      />

      <Button
        onClick={handleCreate}
        className={classes.input}
        variant="contained"
        color="primary"
        disabled={
          !entries?.name ||
          !entries?.lastName ||
          !entries?.grade ||
          !entries?.course ||
          !entries?.institution
        }
      >
        Crear
      </Button>
    </div>
  );
}
